export default __webpack_public_path__ + "static/font-ef1084ec7db93ff6ebd0c94fcb8f6ab0.woff2";